import type {
  BuyerPublicBidDetailDto,
  PublicBidQualificationResponseDto,
  SelectionCriterionDto,
} from "../../../../autogen/bff-api";
import { composeCriterionKey } from "../../../../common/qualification/criterionKey";

export interface BidQualificationProgress {
  fulfilled: number;
  notFulfilled: number;
  pending: number;
  reviewed: number;
  total: number;
  hasRequirements: boolean;
}

export const getBidQualificationProgress = (detail: BuyerPublicBidDetailDto): BidQualificationProgress => {
  const criteria = detail.selectionCriteria ?? [];
  const responsesByKey = new Map(
    (detail.bid.qualificationResponses ?? []).map((r) => [r.criterionKey, r] as const),
  );
  const verdicts = criteria.map((c) => responsesByKey.get(composeCriterionKey(c))?.buyerVerdict ?? null);
  const fulfilled = verdicts.filter((v) => v === true).length;
  const notFulfilled = verdicts.filter((v) => v === false).length;
  const pending = verdicts.length - fulfilled - notFulfilled;
  return {
    fulfilled,
    notFulfilled,
    pending,
    reviewed: fulfilled + notFulfilled,
    total: criteria.length,
    hasRequirements: criteria.length > 0,
  };
};

export interface BidQualificationRow extends PublicBidQualificationResponseDto {
  criterion: SelectionCriterionDto;
}

export const getBidQualificationRows = (detail: BuyerPublicBidDetailDto): BidQualificationRow[] => {
  const criteria = detail.selectionCriteria ?? [];
  const responsesByKey = new Map(
    (detail.bid.qualificationResponses ?? []).map((r) => [r.criterionKey, r] as const),
  );
  return criteria.map((criterion) => {
    const key = composeCriterionKey(criterion);
    const response: PublicBidQualificationResponseDto = responsesByKey.get(key) ?? {
      criterionKey: key,
      buyerVerdict: null,
      buyerComment: null,
    };
    return { ...response, criterion };
  });
};
